import sellerService from "src/services/sellerService";

export const GET_SELLERS_REQUEST = "@seller/get-sellers-request";
export const GET_SELLERS_SUCCESS = "@seller/get-sellers-success";
export const GET_SELLERS_FAILURE = "@seller/get-sellers-failure";

export const GET_ONE_SELLER_REQUEST = "@seller/get_one-seller-request";
export const GET_ONE_SELLER_SUCCESS = "@seller/get_one-seller-success";
export const GET_ONE_SELLER_FAILURE = "@seller/get_one-seller-failure";

export const UPDATE_SELLER_REQUEST = "@seller/update-seller-request";
export const UPDATE_SELLER_SUCCESS = "@seller/update-seller-success";
export const UPDATE_SELLER_FAILURE = "@seller/update-seller-failure";

export function getListSeller(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_SELLERS_REQUEST});
      const response = await sellerService.getListSeller(params);
      dispatch({
        type: GET_SELLERS_SUCCESS,
        payload: {
          response: response.data.data,
          total: response.headers["x-total-items"]
        }
      });
    } catch (error) {
      dispatch({type: GET_SELLERS_FAILURE});
      throw error;
    }
  };
}

export function getOneSeller(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ONE_SELLER_REQUEST});
      const response = await sellerService.getOneSeller(data);
      dispatch({
        type: GET_ONE_SELLER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ONE_SELLER_FAILURE});
      throw error;
    }
  };
}

export function updateSeller(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_SELLER_REQUEST});
      const response = await sellerService.updateSeller(data);
      dispatch({
        type: UPDATE_SELLER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_SELLER_FAILURE});
      throw error;
    }
  };
}
